import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import { Link as RouterLink } from 'react-router-dom'
import Link from '@material-ui/core/Link';
import Typography from "@material-ui/core/Typography";
//Farshid
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import {bindActionCreators} from "redux";
import {loginAction, saveAComment, updateUserProfileAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import Image from 'material-ui-image'
import * as MainConstants from "../../utils/MainConstants";

//import {updateUserProfileAction, saveAComment} from "../../redux/modules/login";
//import {bindActionCreators} from "redux";
//import {connect} from "react-redux";
//import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//End Farshid



const Styles = theme => ({
  root: Object.assign({}, AppBackground, MediumFont),
  gridPane: {width: '50%', display: 'inline-block'},
  paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
  videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
  penInfoPanel: {color: 'white', fontSize: 20},
  penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
  videoPanel: {marginTop: 0},
  penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
  metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  metricInfo: Object.assign({}, AppBackground, ThinBorder)
  
});

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
  rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
  dividerColorPurpole: {
    //marginTop: theme.spacing.unit * 3,
    height: '20px',
    color:"#ffffff",
    //backgroundColor:"#760eb3",
  },
  
  multilineColor:{
    color:'black',
    backgroundColor:'#f5f7e8'
  }
});


class Apartment extends Component {
  
  state = {
    age: '',
    name: 'hai',
    firstname: '',
    lastname:'',
    email:'',
    comment:'',
    userComment:{}
  };
  
  constructor(props) {
    super(props);
    
    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
    this.handleEmailChange= this.handleEmailChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.saveVisitorComment = this.saveVisitorComment.bind(this);
    
    
    
  }
  
  
  componentDidMount() {
    const { isAuthenticated ,updateUserProfileAction} = this.props;
    //isAuthenticated();
    //updateUserProfileAction(this.props.userProfile, this.props.loginData.accessToken);
    updateUserProfileAction(null, this.props.loginData.accessToken);
    //updateAuth();
    // console.log("Farshid the loginData " + this.props.loginData.accessToken)  ;
    
  }
  
  
  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  
  handleFirstNameChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.userComment,{firstname:event.target.value}));
    
    //this.setState({userComment , {{firstname:event.target.value }});
    // this.setState(Object.assign(this.state.firstname, event.target.value));
  }
  
  handleLastNameChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.lastname, event.target.value));
    this.setState(Object.assign(this.state.userComment,{lastname:event.target.value}));
    
  }
  
  handleEmailChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.email,event.target.value));
    this.setState(Object.assign(this.state.userComment,{email:event.target.value}));
    
  }
  handleCommentChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
  }
  
  
  saveVisitorComment(){
    const {saveAComment} = this.props;
    var  returnString="";
    var tempLastName =  this.state.userComment.lastname;
    var tempFirstName = this.state.userComment.firstname;
    var tempEmail = this.state.userComment.email;
    var tempComment = this.state.userComment.comment;
    
    
    if((tempFirstName == null) || (tempFirstName.length == 0)){
      alert("Please provide your first name!");
    }else {
      
      if ((tempLastName == null) || (tempLastName.length == 0)) {
        alert("Please provide your last name!");
      }else {
        
        if ((tempEmail == null) || (tempEmail.length == 0)) {
          alert("Please provide your Email!");
        } else {
          
          if ((tempEmail.indexOf("@") == -1)) {
            alert("Please provide proper Email address!");
          }else{
            if ((tempComment == null) || (tempComment.length == 0)) {
              alert("Please provide your comment!");
            }else{
              //Here send the data to the back end.
              saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment);
              
            }
          }
        }
      }
    }
    
    return returnString;
  }

//Background color was backgroundColor:'#f4f3ed',
  
  
  render() {
    const { classes } = this.props;
    const MyLink = props => <RouterLink to="#top2" {...props} />
    return (
      
      <div id="top1"  style={{ backgroundColor:"#F2F6F8" }}>
        <Grid container spacing={24}>
          
          <Grid   item xs={12} sm={12}  >
            
            
            <div    style = { {  backgroundPosition:'center',  backgroundSize:'cover',  backgroundRepeat:'no-repeat'  }}>
              
              <div style = { {  backgroundPosition:'center',  backgroundSize:'cover', display: 'flex', flexDirection: 'column',alignItems: 'left' ,  backgroundRepeat:'no-repeat'  }}>
                <Typography variant="h3" component="h3" style = { { flex:'1', textAlign: 'center', alignSelf: 'center'  , marginTop:10,  color:'black', fontSize:30}}>
                  {MainConstants.APPLICATION_NAME}&trade; For
                </Typography>
                <Typography variant="h7" component="h7" style = { {flex:'1', textAlign: 'center', alignSelf: 'center'  , marginTop:10,  color:'#BF360C', fontSize:40}}>
                  Modern Parking Enforcement
                </Typography>
                <Typography variant="h7" component="h7" style = { {flex:'1', textAlign: 'center', alignSelf: 'center'  , marginTop:10,  color:'#BF360C', fontSize:40}}>
                 For Apartment Communities
                </Typography>
              </div>
              
              <h6 style = { {textAlign: 'center', alignSelf: 'center', color:'Red', fontSize:20}} ></h6>
              
              <div style = { {textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                  <Grid   item xs={10} sm={10}  >
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                      <br/>
                      Managing parking on private property shouldn’t be a constant source of complaints, conflicts, and inefficiency.
                      Parking issues are one of the top sources of tenant complaints—and one of the biggest operational headaches for property managers.
                      {MainConstants.APPLICATION_NAME}&trade; turns parking enforcement into a streamlined, tenant-friendly process.
                    
                    </Typography>
                  
                  <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300', fontWeight:'bold'}}>
                    Reduce Complaints. Increase Efficiency.
                    </Typography>
                    <br/>
                    
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', topPadding:'100', width:'300'}}>
                      With {MainConstants.APPLICATION_NAME}&trade;, your team can:
                      
                      <ul>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Notify residents instantly before towing</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Resolve violations on-site</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Eliminate unnecessary escalations</span>
                        </li>
                        
                      </ul>
                      Less friction for tenants. Less workload for your staff.
                    </Typography>
                    <br/>
                    
                    <br/>
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300', fontWeight:'bold'}}>
                      Why Property Managers Choose {MainConstants.APPLICATION_NAME}&trade;
                    </Typography>
                    <br/>
                    
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', topPadding:'100', width:'300'}}>
                      <ol  style={ { flexDirection: 'column'}}>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', fontWeight:'bold' , display:'flex'}}> Fewer Tenant Complaints </span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' , display:'flex'}}> Residents appreciate the opportunity to fix mistakes.</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black' , fontWeight:'bold' , display:'flex'}}> Save Staff Time</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', display:'flex'}}> Reduce calls, disputes, and manual coordination with tow companies.</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', fontWeight:'bold', display:'flex'}}> Lower Unnecessary Tow Costs</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', display:'flex'}}> Resolve more issues without dispatching trucks.</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black',fontWeight:'bold', display:'flex'}}> Improve Retention & Satisfaction</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', display:'flex'}}> Small experiences like this shape how tenants feel about your property.</span>
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d' }}>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black',fontWeight:'bold', display:'flex'}}> Centralized Dashboard</span>
                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black', display:'flex'}}> Manage all violations, communications, and actions in one place.</span>
                        </li>
                      </ol>
                    </Typography>
                    <br/>
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300', fontWeight:'bold'}}>
                      Turn Parking Into a Competitive Advantage
                    </Typography>
                    <br/>
                    
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', topPadding:'100', width:'300'}}>
                      
                      In today’s rental market, experience matters.
                      {MainConstants.APPLICATION_NAME}&trade; helps you deliver a modern, tech-enabled living experience that residents notice—and remember.
                    
                    </Typography>
                    
                    <br/>
                    
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', topPadding:'100', width:'300', color:'red'}}>
                    </Typography>
                    <br/>
                    <div style={{paddingLeft:10, paddingBottom:20, display: 'flex', alignSelf:'center' ,flexDirection: 'column', justifyCenter: 'center' }}>
                      <a href="/home"  rel="noreferrer">
                        <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                          &lArr; TowWatch Home
                        </Typography>
                      </a>
                      
                    </div>
                    
                    <br/>
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
              </div>
              <br/>
            </div>
          </Grid>
        </Grid>
      </div>
    
    
    
    );
  }
}

Apartment.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isAuthenticatedBool: state.login.isAuthenticatedBool,
    userProfile: state.login.userProfile,
    loginData:state.login.loginData,
    
    //auth:state.login.loginData,
    //CompanyDeleteResponse:state.account.deleteCompanyResp,
    //CompanySaveResponse:state.account.saveCompanyResp,
    //locationsArray:state.location.locationsArray,
    //vcArray:state.videocontroller.vcArray,
    //camerasArray:state.camera.camerasArray,
    //errorCMsg:state.account.errorCMsg,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    //login:login,
    //handleAuthentication:handleAuthentication,
    //isAuthenticated:isAuthenticated,
    updateUserProfileAction:updateUserProfileAction,
    saveAComment:saveAComment,
    //updateAuth:updateAuth,
    
  }, dispatch);
};

//export default BiomassView;
//export default withStyles(styles)(AboutPlateWiz);




//export default withStyles(styles)(AppView);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Apartment));
